import { Globe } from "lucide-react";
import { useI18n } from "@/lib/i18n/useLocale";

/**
 * Language switcher. It links to the SAME page in the other language using a
 * real, crawlable URL (never a cookie or JS-only toggle), and it disappears on
 * pages that have no translated counterpart rather than dumping the visitor on
 * the home page.
 */
export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { other, isSpanish, t } = useI18n();
  if (!other) return null;
  return (
    <a
      href={other}
      hrefLang={isSpanish ? "en-US" : "es-US"}
      lang={isSpanish ? "en" : "es"}
      title={isSpanish ? t("nav.switchToEnglish") : t("nav.switchToSpanish")}
      className={`flex items-center gap-1.5 whitespace-nowrap rounded-md border border-border px-2.5 py-2 text-sm font-bold text-foreground/80 transition-colors hover:bg-secondary hover:text-foreground ${className}`}
    >
      <Globe className="h-4 w-4" aria-hidden="true" />
      {isSpanish ? "English" : "Español"}
    </a>
  );
}
